import React, { useEffect, useState } from 'react';
import { FlameIcon } from 'lucide-react';
type ScarcityBarProps = {
  tone?: 'light' | 'dark';
};
export function ScarcityBar({
  tone = 'light'
}: ScarcityBarProps) {
  const [spotsLeft, setSpotsLeft] = useState(9);
  useEffect(() => {
    const interval = window.setInterval(() => {
      setSpotsLeft(prev => prev <= 4 ? 9 : prev - 1);
    }, 45000);
    return () => window.clearInterval(interval);
  }, []);
  const total = 150;
  const filled = total - spotsLeft;
  const percent = Math.round(filled / total * 100);
  return <div className={`w-full rounded-2xl border p-4 ${tone === 'dark' ? 'border-white/15 bg-white/5' : 'border-navy/10 bg-white'}`} data-id="element-49" data-mp="2g3ql2v41v9f3">
      <div className="flex items-center justify-between gap-3" data-id="element-50" data-mp="275om0l3vmqug">
        <p className={`flex items-center gap-1.5 text-[12px] font-bold uppercase tracking-wide sm:text-sm ${tone === 'dark' ? 'text-gold' : 'text-navy'}`} data-id="element-51" data-mp="effg3gop3m0">
          <FlameIcon className="h-4 w-4" data-id="element-52" data-mp="33m39t4lfn5dc" />
          Only {spotsLeft} spots left
        </p>
        <span className={`text-[12px] font-semibold tabular-nums ${tone === 'dark' ? 'text-white/60' : 'text-navy/50'}`} data-id="element-53" data-mp="2zlt7q30rgz3r">
          {percent}% claimed
        </span>
      </div>
      <div className={`mt-3 h-3 w-full overflow-hidden rounded-full ${tone === 'dark' ? 'bg-white/10' : 'bg-navy/10'}`} role="progressbar" aria-valuenow={percent} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-54" data-mp="38emrodr5kmny">
        <div className="h-full rounded-full bg-gold transition-all duration-700" style={{
        width: `${percent}%`
      }} data-id="element-55" data-mp="2unrnherlmtqp" />
      </div>
      <p className={`mt-2.5 text-[12px] leading-snug ${tone === 'dark' ? 'text-white/70' : 'text-navy/60'}`} data-id="element-56" data-mp="9vg317nkf2if">
        {spotsLeft} spots remain at the promotional price of $27. Once they run
        out, the price returns to $297.
      </p>
    </div>;
}